import { Flex } from '@chakra-ui/react';
import { PageHeader } from '@bcba/frontend-utils';
import { useTranslation } from '@bcba/react-hooks';
import { ReceivedAccessRequestsTable } from '../components/DigitalDossierAccessRequests/ReceivedAccessRequests/ReceivedAccessRequestsTable';

export const ReceivedDigitalDossierAccessRequestsPage = () => {
  const { t } = useTranslation();
  return (
    <Flex direction={'column'} gap={5}>
      <PageHeader
        title={t('receivedAccessRequests.page.title')}
        description={t('receivedAccessRequests.page.description')}
      />
      <ReceivedAccessRequestsTable />
    </Flex>
  );
};
